import React from "react";
import { CardCustom, Title } from "../../styles";
import { Col, Row } from "antd";
import { useSelector } from "react-redux";
import useStatementContext from "../../../../../../hooks/useStatementContext";
import ButtonStandard from "../../../../../../components/utils/button";
import ImportStatementForm from "./components/form";
import TableStatement from "./components/table";
import { StatementProvider } from "../../../../../../contexts/statementContext";

// import { Container } from './styles';

function StatementLayout() {
  const { translation } = useSelector((state) => state.app);
  const { showStatementImportForm, handleOpenStatementImportForm } =
    useStatementContext();
  return (
    <CardCustom>
      <Row type="flex" className="rowHeader">
        <Col span={20}>
          <Title>{translation.statement.title}</Title>
        </Col>
        {!showStatementImportForm && (
          <Col span={4}>
            <ButtonStandard
              name="buttonCreateBudget"
              buttonType="addNew"
              onClick={handleOpenStatementImportForm}
            >
              {translation.statement.buttonNew}
            </ButtonStandard>
          </Col>
        )}
      </Row>
      {showStatementImportForm === true && <ImportStatementForm />}
      {!showStatementImportForm && <TableStatement />}
    </CardCustom>
  );
}

const Statement = () => {
  return (
    <StatementProvider>
      <StatementLayout />
    </StatementProvider>
  );
};

export default Statement;
